<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item,index) in breadcrumbList"
        :key="item.path"
        :to="{ path: item.path }"
      >{{item.meta.title}}</el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
  export default {
    data() {
      return {
        breadcrumbList: []
      }
    },
    created(){
      this.getBreadcrumbList()
    },
    methods:{
      getBreadcrumbList(){
        this.breadcrumbList = this.$route.matched || []
      }
    },
    watch:{
      $route(newVal){
        this.getBreadcrumbList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .breadcrumb-enter-active,
  .breadcrumb-leave-active {
    transition: all .5s;
  }

  .breadcrumb-enter,
  .breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(20px);
  }

  .breadcrumb-move {
    transition: all .5s;
  }

  .breadcrumb-leave-active {
    position: absolute;
  }
</style>
